var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54381 16.3393L6.71048 15.0298C5.88933 14.4432 5.47876 14.15 5.2571 13.7192C5.03543 13.2885 5.03543 12.7839 5.03543 11.7748V9.22509C5.03543 8.90375 5.03543 8.63356 5.04259 8.40064L9.86876 11.8479V17.2313C9.51201 17.0308 9.09575 16.7335 8.54381 16.3393ZM11.8688 17.2313C12.2255 17.0308 12.6418 16.7335 13.1937 16.3393L15.0271 15.0298C15.8482 14.4432 16.2588 14.15 16.4804 13.7192C16.7021 13.2885 16.7021 12.7839 16.7021 11.7748V9.22509C16.7021 8.90375 16.7021 8.63357 16.6949 8.40064L11.8688 11.8479V17.2313ZM15.8297 6.56089L10.8688 10.1044L5.90787 6.56089C6.11916 6.39253 6.38196 6.20482 6.71048 5.97016L8.54381 4.66064C9.66649 3.85872 10.2278 3.45776 10.8688 3.45776C11.5097 3.45776 12.071 3.85872 13.1937 4.66064L15.0271 5.97016C15.3556 6.20482 15.6184 6.39253 15.8297 6.56089Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.cce1f43f1e2f199ad9d0b46585b04ad6.svg";
export { ForwardRef as ReactComponent };